import React, { FC } from 'react';
import styled from 'styled-components';
import { Black, Red } from '../../styles/colours';
import { Medium, Regular } from '../../styles/fonts';

interface IQuantityProps {
  quantity: number;
}

interface IQuantityPropsAndUnit {
  quantity: number;
  unitOfMeasure: string;
}

export const HighlightNegativeQuantity = styled.div<IQuantityProps>`
  display: inline-block;
  color: ${props => (props.quantity < 0 ? `${Red}` : `${Black}`)};
  font-family: ${props => (props.quantity < 0 ? `${Medium}` : `${Regular}`)};
`;

const Quantity: FC<IQuantityPropsAndUnit> = ({ quantity, unitOfMeasure }) => {
  if (quantity === 0) {
    return <span>—</span>;
  }
  return (
    <div>
      {quantity} {unitOfMeasure}
    </div>
  );
};

export { Quantity };
